import * as React from 'react'
import { Grid } from '@mds/mds-reactjs-library'
import ViewLayout, { classes } from '../components/ViewLayout'

type ErrorProps = {
  icon: JSX.Element
  title?: string
  text?: string | JSX.Element
}

const Error = ({ icon, title, text }: ErrorProps): JSX.Element => (
  <ViewLayout>
    <section className={classes.wrappingBox}>
      <Grid item span={12}>
        <div className={classes.rowsContentWrapper}>
          <div className={classes.actionImage}>{icon}</div>
          {title && (
            <div>
              <div className={classes.titleWrapper}>{title}</div>
              {text && <div className={classes.subtitleWrapper}>{text}</div>}
            </div>
          )}
        </div>
      </Grid>
    </section>
  </ViewLayout>
)

export default Error
